// Global shop links shown in header/footer — edit with your real URLs
export const globalShops = [
  {
    id: 'etsy',
    platform: 'etsy',
    url: 'https://www.etsy.com/shop/your-shop',
  },
  {
    id: 'kofi',
    platform: 'kofi',
    url: 'https://ko-fi.com/your-page',
  },
]
